export enum modals {
  RESET_PERMISSIONS_MODAL = 'RESET_PERMISSIONS_MODAL'
} 
